import { render, staticRenderFns } from "./SingleButtonConfirmation.vue?vue&type=template&id=b233e0a2&"
import script from "./SingleButtonConfirmation.vue?vue&type=script&lang=js&"
export * from "./SingleButtonConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports